var BackOffice = (function(backOffice, $) {
	var eventChannel = {
		events: {},
		subscribe: function(eventName, fn) {
			this.events[eventName] = this.events[eventName] || [];
			this.events[eventName].push(fn);
		},
		unsubscribe: function(eventName, fn) {
			if (this.events[eventName]) {
				for (var i = 0; i < this.events[eventName].length; i++) {
					if (this.events[eventName][i] === fn) {
						this.events[eventName].splice(i, 1);
						break;
					}
				}
			}
		},
		broadcast: function(eventName, data) {
			if (this.events[eventName]) {
				this.events[eventName].forEach(function(fn) {
					fn(data);
				});
			}
		}
	};

	return $.extend(backOffice, { EventChannel: eventChannel });
})(BackOffice || {}, jQuery);
